export default __webpack_public_path__ + "9944e7eb6409139017c0b58cbc032f34.png";